import React from "react";
import { Grid2 as Grid, Typography, Divider } from "@mui/material";
import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";

export const PermissionFields = React.memo(() => {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Divider />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Typography style={{ fontSize: 18, color: "primary.main" }}>
          {translate("v1/user_admin.titles.permissions")}
        </Typography>
      </Grid>

      <Grid size={{ xs: 12, md: 4 }}>
        <Form.Checkbox
          name="is_admin"
          label={translate("v1/user_admin.fields.is_admin")}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 4 }}>
        <Form.Checkbox
          name="agreement_superuser"
          label={translate("v1/user_admin.fields.agreement_superuser")}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <Form.Checkbox
          name="is_tester"
          label={'Se é um usuario de Teste'}
        />
      </Grid>
    </Grid>
  );
});
